export default "__VITE_ASSET__C_KNq5vI__"